import {
  SINGLE_COLUMN_TEMPLATE,
  ESPOT_COMPONENT,
  MY_EQUIPMENT_COMPONENT,
  PM_KIT_WIDGET_COMPONENT,
  PRODUCTCARD_COMPONENT,
  YOUTUBE_COMPONENT
} from './constants';

// Templates
import SingleColumn from './templates/SingleColumn';

// Components
import Espot from './components/Espot';
import MyEquipmentCTA from './components/MyEquipmentCTA';
import PMKitWidgetCTA from './components/PMKitWidgetCTA';
import ProductCardGrid from './components/ProductCardGrid/ProductCardGrid';
import YoutubeWidget from './components/YoutubeWidget/YoutubeWidget';

export const templateMapping = {
  [SINGLE_COLUMN_TEMPLATE]: SingleColumn
};
export const componentMapping = {
  [ESPOT_COMPONENT]: Espot,
  [MY_EQUIPMENT_COMPONENT]: MyEquipmentCTA,
  [PM_KIT_WIDGET_COMPONENT]: PMKitWidgetCTA,
  [PRODUCTCARD_COMPONENT]: ProductCardGrid,
  [YOUTUBE_COMPONENT]: YoutubeWidget
};
